import Head from "expo-router/head";

import Redirect from "@/components/BreadcrumbRedirect";
import { brandName } from "@/config/brand";

export default function NotFound() {
  return (
    <>
      <Head>
        <title>{`Page Not Found — ${brandName}`}</title>
      </Head>
      <Redirect href="/" reason="404" />
    </>
  );
}
